<script setup lang="ts">
import BaseMessage from '@/overlays/BaseMessage.vue';

defineEmits<{ close: [] }>();
</script>

<template>
  <BaseMessage
    variant="error"
    :title="$t('global.somethingWentWrong')"
    @close="$emit('close')"
  />
</template>
